export default {
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    copy: 'Copy',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    info: 'Info',
    requestError: 'Request Error',
    authFailed: 'Authentication failed, please try again',
    networkError: 'Network error, please try a different network',
    today: 'Today',
    tomorrow: 'Tomorrow',
    noData: 'No data available',
    submit: 'Submit',
    or: 'or',
    switch: 'Switch',
    linkCopied: 'Link copied',
    month: 'Month',
    day: 'Day',
    start: 'Start',
    end: 'End',
    startEnd: 'Start/End',
    view: 'View',
    yearsOld: ' years old',
    switchLanguageTo: 'Switch language to',
    sunday: 'Sun',
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    about: 'About',
    from: 'From',
    fromPerNight: 'from/night',
    loadFailed: 'Load Failed',
    // Date formats
    dateFormat: 'MMM DD',
    shortDateFormat: 'MM-DD',
    // Weekdays for date formatting
    weekdayShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dateWithWeekday: 'MMM DD ddd',
  },
  hotel: {
    roomDetails: 'Room Details',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    nights: 'nights',
    totalNights: '{count} night(s)',
    price: 'Price',
    totalPrice: 'Total Price',
    totalPriceWithTaxes: 'Total Price (incl. taxes/fees)',
    cancelPolicy: 'Cancellation Policy',
    refundable: 'Refundable',
    nonRefundable: 'Non-Refundable',
    partiallyRefundable: 'Partially Refundable',
    freeCancel: 'Free Cancellation',
    paidCancel: 'Paid Cancellation',
    checkInTime: 'Check-in Time',
    checkOutTime: 'Check-out Time',
    checkInCheckOutTime: 'Check-in/Check-out Time',
    selectCheckInCheckOutDate: 'Select Check-in and Check-out Date',
    after: 'After',
    before: 'Before',
    contactHotelForCheckIn: 'Please contact the hotel to confirm check-in time',
    contactHotelForCheckOut: 'Please contact the hotel to confirm check-out time',
    guestInfo: 'Guest Information',
    guest: 'Guest',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Phone',
    email: 'Email',
    adults: 'Adults',
    children: 'Children',
    bedType: 'Bed Type',
    bedPreference: 'Bed Preference',
    roomType: 'Room Type',
    facilities: 'Facilities',
    amenities: 'Amenities',
    breakfast: 'Breakfast',
    noBreakfast: 'No Breakfast',
    paymentMethod: 'Payment Method',
    payNow: 'Pay Now',
    payAtHotel: 'Pay at Hotel',
    submitOrder: 'Submit Order',
    orderConfirmation: 'Order Confirmation',
    bookingDetails: 'Booking Details',
    priceDetails: 'Price Details',
    taxes: 'Taxes',
    fees: 'Fees',
    additionalFees: 'Additional Fees',
    mandatoryFees: 'Mandatory Fees',
    resortFees: 'Resort Fees',
    taxInfo:
      'This fee includes the estimated amount paid by travel service providers (such as hotels, car rental companies) for their applicable taxes, and/or fees retained by us as compensation for our and/or their services.',
    paymentIncomplete: 'Payment Incomplete',
    paymentFailed: 'Payment Failed',
    paymentSuccess: 'Payment Successful',
    pleaseCompletePayment: 'Please complete your payment',
    loginPaypal: 'Login to PayPal Account to Pay',
    paypalInfo: 'PayPal Login Information',
    paypalDesc1: 'Login page will open in a new window',
    paypalDesc2: 'Login to your PayPal account and complete payment',
    paypalDesc3: 'After successful payment, you will receive order confirmation',
    readBeforeBooking: 'Read Before Booking',
    mustRead: 'Must Read',
    agreementAndTerms: 'Terms and Conditions',
    iAgree: 'I agree to the',
    supplierTerms: 'Supplier Terms and Conditions',
    roomsCount: 'rooms',
    averagePricePerNight: 'Average Price Per Night',
    dailyPriceDetails: 'Daily Price Details',
    onlinePayment: 'Online Payment',
    paymentDetails: 'Payment Details',
    currency: 'Currency',
    exchangeRate: 'Exchange Rate',
    estimatedPrice: 'Estimated Price',
    priceChangeWarning:
      'This price is an estimate based on the current exchange rate and may change at check-in.',
    hotelName: 'Hotel Name',
    address: 'Address',
    copyAddress: 'Copy',
    addressCopied: 'Address Copied',
    contact: 'Contact',
    callHotel: 'Call Hotel',
    emailHotel: 'Email Hotel',
    specialRequests: 'Special Requests',
    noSpecialRequests: 'No Special Requests',
    policies: 'Policies',
    checkInPolicy: 'Check-in Policy',
    checkOutPolicy: 'Check-out Policy',
    petPolicy: 'Pet Policy',
    childrenPolicy: 'Children Policy',
    groupPolicy: 'Group Reception Policy',
    accessMethod: 'Access Method',
    specialInstructions: 'Special Instructions',
    knowBeforeYouGo: 'Know Before You Go',
    onSitePayments: 'On-Site Payments',
    paymentOptions: 'Payment Options',
    acceptedCards: 'Accepted Cards',
    hotelInfo: 'Hotel Information',
    openingTime: 'Opening Time',
    roomCount: 'Room Count',
    hotelRating: 'Hotel Rating',
    hotelPhone: 'Hotel Phone',
    hotelHighlights: 'Hotel Highlights',
    bookingRules: 'Booking Rules',
    importantTips: 'Important Tips',
    facilityServices: 'Facility Services',
    hotelIntroduction: 'Hotel Introduction',
    hotelDescription: 'Hotel Description',
    otherAmenities: 'Other Amenities Offered by This Hotel',
    roomFeatures: 'Room Features',
    otherFacilitiesServices: 'Other Facilities/Services Include',
    hotelPolicies: 'Hotel Policies',
    checkInStart: 'Check-in Starts',
    checkInEnd: 'Check-in Ends',
    checkOutBefore: 'Check-out Before',
    pets: 'Pets',
    childrenAndBeds: 'Children and Extra Beds',
    paymentMethods: 'Payment Methods',
    needToKnow: 'Need to Know',
    otherNotes: 'Other Notes',
    otherItems: 'Other Items',
    hotelFacilities: 'Hotel Facilities',
    noFacilityInfo: 'No facility information available',
    viewRoomTypes: 'View Room Types',
    noPhone: 'No phone available',
    guestMinAge: 'Guests must be at least',
    minimumCheckInAge: 'Minimum Check-in Age',
    // Order status
    statusPaying: 'Pending Payment',
    statusCanceled: 'Cancelled',
    statusChecking: 'Upcoming',
    statusCompleted: 'Completed',
    yearsOld: 'years old',
    rooms: 'rooms',
    acceptedPayments: 'Accepted Payments',
    guestInfoTip: 'Please fill in the names of all guests',
    invalidPhone: 'Please enter a valid phone number',
    invalidEmail: 'Please enter a valid email address',
    nameCannotContainChinese:
      'Name cannot contain Chinese characters, please use pinyin or English',
    nameOnlyEnglish: 'Name can only contain English letters',
    pleaseEnterName: 'Please enter name',
    pleaseEnterPhone: 'Please enter phone number',
    pleaseEnterEmail: 'Please enter email address',
    completeGuestInfo: 'Please complete guest information',
    priceChanged: 'Price changed, please re-book',
    networkError: 'Network error, please re-book',
    bookingFailed: 'Booking failed',
    bookingSuccess: 'Booking successful',
    orderCreated: 'Order created successfully',
    paymentCancelled: 'Payment cancelled',
    paymentError: 'Payment error',
    tryAgain: 'Try Again',
    goToOrders: 'Go to Orders',
    goToHome: 'Go to Home',
    noRooms: 'No rooms available',
    selectRoom: 'Select Room',
    selectDate: 'Select Date',
    selectGuests: 'Select Guests',
    search: 'Search',
    searchHotels: 'Search Hotels',
    noResults: 'No results found',
    tryDifferentSearch: 'Try a different search',
    loadMore: 'Load More',
    noMore: 'No more results',
    retry: 'Retry',
    close: 'Close',
    // Room selection related
    room: 'Room',
    selectRoomsAndGuests: 'Select Rooms and Guests',
    selectChildAge: 'Select Child Age',
    adultsCount: 'Adults Count',
    childrenCount: 'Children Count',
    selectChildAgeInfo:
      'Please select the age of each child to help us choose the right room and bed type, and possibly special offers',
    child: 'Child',
    underOneYear: 'Under 1 year',
    ageRequired: 'Age is required',
    selectAge: 'Select Age',
    deleteRoom: 'Delete Room',
    addAnotherRoom: 'Add Another Room',
    pleaseSelectBedPreference: 'Please select bed preference',
    bedPreferenceNotGuaranteed:
      'Bed preference cannot be guaranteed, please contact hotel for confirmation',
    selectPreference: 'Select Preference',
    total: 'Total',
    // Hotel list related
    hotelList: 'Hotel List',
    noHotelsFound: 'Sorry, no hotels found matching your criteria, please try a different search',
    soldOutChangeTime: 'Sold out for this time, please change the date or search for another hotel',
    roomsLeft: 'Only',
    book: 'Book',
    quickBook: 'Quick Book',
    bookNow: 'Book Now',
    // Room details related
    specialCheckInInstructions: 'Special Check-in Instructions',
    childrenAndExtraBeds: 'Children and Extra Beds',
    importantNotes: 'Important Notes',
    noBookingInfo: 'No booking information available',
    hasWifi: 'Has WiFi',
    noWifi: 'No WiFi',
    freeParking: 'Free Parking',
    guests: 'guests',
    accommodates: 'Accommodates',
    floor: 'floor',
    roomFacilities: 'Room Facilities',
    noFacilitiesInfo: 'No facilities information available',
    roomRateDetails: 'Room Rate Details',
    noCancelPolicy: 'No cancellation policy available',
    avgPricePerRoomPerNight: 'Average Price Per Room Per Night',
    zeroRooms: '0 rooms',
    searchPlaceholder: 'Destination, accommodation, or landmark',
    searchResults: 'Search Results',
    noSearchResults: 'Sorry, no results found for your search criteria',
    // Fill order page additions
    pinyinOrEnglish: 'Pinyin or English',
    pleaseEnterLastName: 'Please enter last name',
    pleaseEnterFirstName: 'Please enter first name',
    noChineseOrNumbers: 'Cannot contain Chinese or numbers',
    roomNumber: 'Room {number}',
    companionsCannotCheckIn: 'Companions cannot initiate check-in procedures',
    orderPayment: 'Order Payment',
    pleaseCompletePaymentWithin: 'Please complete payment within',
    completePayment: '',
    reorderWarning: 'Re-booking may result in price increase or no availability!',
    guestName: 'Guest Name',
    meals: 'Meals',
    includingTaxesAndFees: 'Including taxes and fees',
    pleaseEnterContactPhone: 'Please enter contact phone number',
    pleaseEnterValidPhone: 'Please enter a valid phone number',
    emailForItinerary: 'For receiving itinerary',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    roomsAndNights: '{rooms} room(s) X {nights} night(s)',
    paidCancellation: 'Paid Cancellation',
    limitedFreeCancellation: 'Limited Free Cancellation',
    resortFee: 'Resort Fee',
    otherFees: 'Other Fees',
    otherFeesTotal: 'Other Fees Total',
    submitAgreement: 'By submitting, you agree to',
    paypalLoginNewWindow: 'Login page will open in a new window',
    paypalLoginAndPay: 'Log in to your PayPal account and complete payment',
    paypalSuccessConfirmation: 'After successful payment, you will receive order confirmation',
    additionalTax: 'Additional Tax',
    priceEstimateNote:
      '*This price is an estimate based on current exchange rates and may change at check-in.',
    paymentConfirming: 'Confirming Payment',
    doNotClosePage: 'Please do not close this page...',
    paypalPaymentIncomplete: 'PayPal payment incomplete.',
    beforeCheckOut: ' before check-out',
    afterCheckIn: ' after check-in',
    noMeals: 'No meals',
    noMealInfo: 'No meal information available',
    loginPaypalToPay: 'Log in to PayPal to pay',
    completePaymentWithin: 'Please complete payment within',
    rebookingMayIncrease: 'Rebooking may result in price increase or no availability!',
    priceChangedReorder: 'Price changed, please reorder',
    networkErrorReorder: 'Network error, please reorder',
    taxDescription: 'Tax Description',
    taxInfoTip:
      'This fee includes estimated amounts paid by travel service providers (such as hotels, car rental companies) for their tax obligations, and/or fees, cleaning charges, and other costs based on your booking, and/or fees retained by us, hotel suppliers, or the website you booked through as compensation for our and/or their services. These fees vary depending on location, amount, and booking method.',
    age: 'Age',
    priceCheckFailed: 'Room rate query failed, please search again',
    priceAbnormal: 'Price Abnormal',
    priceCheckError: 'Room rate query error, please search again',
    popupOpenedInitPaypal: 'Popup opened, initializing PayPal button',
    noPendingOrderId: 'No pending order ID',
    copySuccess: 'Copied successfully',
    getOpenidFailed: 'Failed to get openid',
    bedTypeNotSpecified: 'Bed type not specified',
    pleasePayInExternalBrowser: 'Please complete payment in external browser',
    paymentPageOpened: 'Payment page opened, please complete payment',
    getPaymentLinkFailed: 'Failed to get payment link',
    paymentFailedRetry: 'Payment failed, please retry',
    preparingPayment: 'Preparing payment...',
    payWithOpenid: 'Pay with openid',
    getPaymentParamsFailed: 'Failed to get payment parameters',
    invokingPayment: 'Invoking payment...',
    userCancelledPayment: 'User cancelled payment',
    paymentErrorRetry: 'Payment error, please retry',
    wechatPaymentError: 'WeChat payment error',
    initPaypalButton: 'Initialize PayPal button, order ID',
    // Hotel image gallery related
    gallery: 'Gallery',
    allPhotos: 'All Photos',
    // Languages
    chineseMandarinEnglish: 'Chinese (Mandarin), English',
    // Room item related
    hasBreakfast: 'Has Breakfast',
    soldOut: 'Sold Out',
    noImage: 'No Image',
  },
  order: {
    myOrders: 'My Orders',
    orderDetails: 'Order Details',
    orderNumber: 'Order Number',
    orderDate: 'Order Date',
    orderStatus: 'Order Status',
    pending: 'Pending Confirmation',
    confirmed: 'Confirmed',
    cancelled: 'Cancelled',
    completed: 'Completed',
    refunding: 'Refunding',
    refunded: 'Refunded',
    paymentPending: 'Payment Pending',
    paymentConfirmed: 'Payment Confirmed',
    toPay: 'To Pay',
    toTravel: 'Upcoming',
    cancelBooking: 'Cancel',
    rebook: 'Rebook',
    viewDetails: 'View Details',
    refundAmount: 'Refund Amount',
    refundStatus: 'Refund Status',
    applyRefund: 'Apply Refund',
    refundPolicy: 'Refund Policy',
    noOrders: 'No orders yet',
    startBooking: 'Start Booking',
    timeRemaining: 'Time Remaining',
    remainingTimePending: 'Remaining {time} pending payment',
    minutesRemaining: 'minutes remaining',
    paymentExpired: 'Payment Expired',
    cancelConfirm: 'Are you sure you want to cancel this booking?',
    cancelSuccess: 'Booking cancelled successfully',
    cancelFailed: 'Failed to cancel booking',
    refundSuccess: 'Refund applied successfully',
    refundFailed: 'Failed to apply refund',
    searchOrders: 'Search Orders',
    // Cancel reason related
    cancelReason: 'Cancel Reason',
    personalReason: 'Personal reason, unable to travel',
    changeTravelDate: 'Need to change travel date',
    planChanged: 'Plans changed, not going anymore',
    otherReason: 'Other reason',
    additionalDescription: 'Additional Description',
    enterDescription: 'Please enter problem description~',
    cancelReasonRequired: 'Cancel reason cannot be empty',
    // Order status
    statusConfirming: 'Pending Confirmation',
    statusPaying: 'Pending Payment',
    statusChecking: 'Upcoming',
    statusCompleted: 'Completed',
    statusCanceled: 'Cancelled',
    paidCancellation: 'Paid Cancellation',
    limitedFreeCancellation: 'Limited Free Cancellation',
    hotelType: 'Hotel',
    totalNights: '{count} night(s)',
    remainingTime: '{time} remaining',
    roomDetails: 'Room Details',
    roomNumber: 'Room {number}',
    adultsCount: '{count} Adult(s)',
    childrenCount: '{count} Child(ren)',
    // Cancel order related
    cancelWarning:
      'Cancelling the booking may incur fees according to the cancellation policy. Please proceed with caution.',
    refundApplicationSubmitted: 'Refund application submitted',
    applicationSubmitted: 'Application submitted',
    verificationFailed: 'Verification failed, please verify again',
    // Order detail page
    pleaseCompletePaymentWithin: 'Please complete payment within',
    completePayment: 'Complete Payment',
    rebookingWarning: 'Rebooking may result in price increase or no availability',
    orderSubmitted: 'Your order has been submitted and is waiting for hotel confirmation',
    roomConfirmationNumber: 'Room {number} Confirmation Number',
    details: 'Details',
    viewCancelPolicy: 'View',
    viewBookingInfo: 'View check-in instructions, special notes, fee descriptions, etc.',
    viewRefundInfo: 'View Refund Info',
    refundToPaypalAccount: 'Refund to your PayPal account',
    refundedStatus: 'Refunded',
    viewPaymentInfo: 'View Payment Info',
    totalFees: 'Total Fees',
    paidFees: 'Paid Fees',
    paymentSuccessful: 'Payment Successful',
    paymentDeducted: 'Payment has been successfully deducted for this order',
    viewOrders: 'You can view it in "My Orders"',
    orderInfo: 'Order Information',
    orderTime: 'Order Time',
    paymentTime: 'Payment Time',
    saveReceipt: 'Save Receipt',
    cancelOrder: 'Cancel Order',
    cancelOrderTitle: 'You need to cancel the order',
    cancelOrderDesc:
      'You are about to cancel the entire booking, please review the information below before cancelling',
    refundDetails: 'Refund Details',
    unpaidCancelNote:
      'This order has not been paid yet. No fees will be charged after cancellation.',
    confirmCancel: 'Confirm Cancellation',
    cancelRules: 'Cancellation Rules',
    noPolicyAvailable: 'No policy available',
    missingParameters: 'Missing required parameters',
    getRoomDetailFailed: 'Failed to get room details',
    roomDetailIncomplete: 'Room detail data is incomplete',
    emailSentSuccess: 'Email sent successfully',
    emailSentFailed: 'Failed to send email',
    taxFeeDescription:
      'These taxes are tax recovery fees paid to suppliers (e.g. hotels); please refer to our Terms of Use for details. Service fees are compensation for providing booking services, which may include fees charged by suppliers',
    taxFeeTitle: 'Tax Fee Description',
    copyFailed: 'Copy failed',
    copySuccess: 'Copied successfully',
    includingTaxesAndFees: 'Including taxes and fees',
    payAtHotelNote: 'Pay at Hotel',
    mandatoryFeesNote: 'Mandatory Fees',
    resortFeesNote: 'Resort Fees',
    additionalTaxNote: 'Additional Tax',
    ageYears: '{age} years old',
  },
  user: {
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    profile: 'My Profile',
    settings: 'Settings',
    language: 'Language',
    currency: 'Currency',
    selectLanguage: 'Select Language',
    selectCurrency: 'Select Currency',
    currencyDesc:
      'The applicable price will be converted to your selected currency and displayed in that currency. The currency used at payment may vary depending on your booking and may also incur service fees.',
    myInfo: 'My Information',
    editInfo: 'Edit Information',
    avatar: 'Avatar',
    nickname: 'Nickname',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    city: 'City',
    country: 'Country',
    postalCode: 'Postal Code',
    about: 'About',
    help: 'Help',
    contactUs: 'Contact Us',
    faq: 'FAQ',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    supplierTerms: 'Supplier Terms and Conditions',
    userAgreement: 'User Agreement',
    logoutConfirm: 'Are you sure you want to logout?',
    logoutSuccess: 'Logged out successfully',
    loginSuccess: 'Logged in successfully',
    loginFailed: 'Login failed',
    registerSuccess: 'Registered successfully',
    registerFailed: 'Registration failed',
    updateSuccess: 'Updated successfully',
    updateFailed: 'Update failed',
    welcome: 'Hello, Traveler!',
    slogan: 'AYH, Quality Hotels at Your Fingertips',
    switchToChinese: '切换到中文',
    switchToEnglish: 'Switch to English',
    loginStatus: 'Login Status',
    notLoggedIn: 'Not Logged In',
  },
  login: {
    title: 'Login / Register',
    authLogin: 'Authorized Login',
    recentAuthorized:
      'You have recently authorized the above account to log in. Click confirm to log in automatically.',
    slogan: 'Login/Register to see more quality hotels',
    phoneShortcut: 'Phone Shortcut Login',
    loginNow: 'Login Now',
    lastLoggedIn: 'Last Logged In',
    useOtherPhone: 'Use Other Phone Number',
    accountLogin: 'Account Login',
    enterAccount: 'Please enter account',
    enterPassword: 'Please enter password',
    forgetPassword: 'Forgot Password?',
    phoneCodeLogin: 'Phone Code Login',
    welcome: 'Welcome to Login/Register',
    enterPhone: 'Please enter phone number',
    enterCode: 'Enter code',
    getCode: 'Get Code',
    resetPassword: 'Reset Password',
    setNewPassword: 'Set New Password',
    passwordTip: 'Password must be 8-18 characters and contain letters, numbers, and symbols',
    complete: 'Complete',
    agreePrefix: 'I have read and agree to',
    serviceAgreement: 'the Service Agreement',
    agreeSuffix:
      ', if your phone is not registered, it will be automatically registered when you log in',
    readAndAgree: 'Please read and agree to the Platform Service Agreement of ',
  },
  errorPage: {
    errorOccurred: 'Sorry, we encountered some issues',
  },
  home: {
    home: 'Home',
    welcome: 'Welcome',
    searchHotels: 'Search Hotels',
    destination: 'Destination',
    checkIn: 'Check In',
    checkOut: 'Check Out',
    guests: 'Guests',
    guestCount: '{count} Guests',
    rooms: 'Rooms',
    roomCount: '{count} Rooms',
    search: 'Search',
    hotDeals: 'Hot Deals',
    popularDestinations: 'Popular Destinations',
    recentSearches: 'Recent Searches',
    clearHistory: 'Clear History',
    noRecentSearches: 'No recent searches',
    featured: 'Featured',
    recommendations: 'Recommendations',
    viewAll: 'View All',
    seeMore: 'See More',
  },
  payment: {
    paypal: 'PayPal',
    creditCard: 'Credit Card',
    debitCard: 'Debit Card',
    wechat: 'WeChat Pay',
    alipay: 'Alipay',
    bankTransfer: 'Bank Transfer',
    selectPaymentMethod: 'Select Payment Method',
    paymentMethod: 'Payment Method',
    cardNumber: 'Card Number',
    expiryDate: 'Expiry Date',
    cvv: 'CVV',
    cardholderName: 'Cardholder Name',
    billingAddress: 'Billing Address',
    sameAsShipping: 'Same as Shipping Address',
    paymentProcessing: 'Payment Processing',
    paymentConfirming: 'Confirming Payment',
    doNotClose: 'Please do not close this page',
    paymentSuccessful: 'Payment Successful',
    paymentFailed: 'Payment Failed',
    paymentCancelled: 'Payment Cancelled',
    tryAgain: 'Try Again',
    returnToOrder: 'Return to Order',
    refund: 'Refund',
    refundProcessing: 'Refund Processing',
    refundSuccessful: 'Refund Successful',
    refundFailed: 'Refund Failed',
    // Payment component related
    cashier: 'Cashier',
    scanToPay: 'Scan to Pay',
    paymentCompleted: 'Payment Completed',
    wechatPay: 'WeChat Pay',
    alipayPay: 'Alipay',
    amountToPay: 'Amount to Pay: ',
    scanWithWechat: 'Please scan with WeChat to pay',
    scanWithAlipay: 'Please scan with Alipay to pay',
    skipPayment: 'Skip Payment',
    confirmPaymentComplete: 'Please confirm if payment is completed',
    retryPayment: 'Payment issue, retry payment',
  },
  // Form related
  form: {
    name: 'Name',
    enterName: 'Please enter name',
    nameRequired: 'Name is required',
    phoneNumber: 'Phone Number',
    enterPhoneNumber: 'Please enter phone number',
    phoneRequired: 'Phone number is required',
    documentInfo: 'Document Information',
    identity: 'Identity',
    optionalButRequired: 'Optional, but required when purchasing tickets',
    idCard: 'ID Card',
    idCardRequired: 'ID card is required',
  },
  // Refund related
  refund: {
    process: 'Refund Process',
    submitApplication: 'Submit Refund Application',
    success: 'Refund Successful',
    failed: 'Refund Failed',
    notRefunded: 'Not Refunded',
    processing: 'Refunding',
  },
  // Page title related
  page: {
    contactUs: 'Contact Us',
    selectDestination: 'Select Destination',
    supplierTerms: 'Supplier Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    travelers: 'Travelers',
    selectContact: 'Select Contact',
    payment: 'Payment',
    my: 'My',
    settings: 'Settings',
    hotelList: 'Hotel List',
    userAgreement: 'User Agreement',
    noTravelers: 'No travelers',
    addTraveler: 'Add Traveler',
    noInvoice: 'No invoices',
    selectRoomAndGuests: 'Select Rooms and Guests',
  },
  // Search related
  search: {
    historyDetected: 'Search history detected',
    requestReturned: 'Request returned',
    saved: 'Saved',
    history: 'Search History',
    clearHistory: 'Are you sure you want to clear the search history?',
    tip: 'Tip',
  },
  // Location related
  location: {
    final: 'Final location',
    beijing: 'Beijing',
    beijingPalaceMuseum: 'Beijing Palace Museum',
  },
  // App related
  app: {
    name: 'Hi Travel',
  },
  // Tabbar related
  tabbar: {
    home: 'Home',
    my: 'My',
  },
  // Number related
  number: {
    one: 'One',
    two: 'Two',
    three: 'Three',
    four: 'Four',
    five: 'Five',
    six: 'Six',
    seven: 'Seven',
    eight: 'Eight',
  },
  // Age related
  age: {
    underOne: 'under 1 year',
    oneYear: '1 year',
    twoYears: '2 years',
    threeYears: '3 years',
    fourYears: '4 years',
    fiveYears: '5 years',
    sixYears: '6 years',
    sevenYears: '7 years',
    eightYears: '8 years',
    nineYears: '9 years',
    tenYears: '10 years',
    elevenYears: '11 years',
    twelveYears: '12 years',
    thirteenYears: '13 years',
    fourteenYears: '14 years',
    fifteenYears: '15 years',
    sixteenYears: '16 years',
    seventeenYears: '17 years',
    eighteenYears: '18 years',
    yearsOldSuffix: ' years',
  },
  // Error message related
  error: {
    maxGuestsReached: 'Maximum number of guests reached (20 people)',
    maxGuestsPerRoom: 'Maximum 16 guests per room',
    maxRoomsReached: 'Maximum 8 rooms can be added',
    noHotelsFoundRecommendation:
      'Sorry, no hotels found matching your requirements. We have automatically recommended your recently viewed destinations for your convenience',
    checkOutDateInPast: 'Check-out date cannot be in the past, automatically updated',
  },
  // Debug related
  debug: {
    hello: 'Hello',
    requestingApple: 'Requesting Apple server',
    userPaymentSuccess: 'User payment successful',
    userCancelPayment: 'User cancelled payment',
    checkingMissedOrders: 'Checking for missed orders',
    missedOrderResult: 'Missed order result: ',
    noMissedOrders: 'No missed orders',
    hasMissedOrders: 'Has missed orders',
    processingPaymentResult: 'Processing payment result...',
  },
  // Image related
  image: {
    saveImage: 'Save Image',
    saveSuccess: 'Save Successful',
  },
  // Transaction details related
  transaction: {
    title: 'Transaction Details',
    paid: 'Paid',
    viewRefundHistory: 'View Refund History',
    transactionDetails: 'Transaction Details',
    refundStartedAt: 'Refund Started At',
    transactionDate: 'Transaction Date',
    processor: 'Processor',
    processorName: 'HaoLvYou.com',
    paymentMethod: 'Payment Method',
    refundHistory: 'Refund History',
    refundCompleted: 'Refund completed.',
    refundCompletedAt: 'Refunded on {date}',
    refundStartedAtDate: 'Refund started on {date}',
    refundProcessingTime: 'Refund usually takes 7-12 calendar days to complete.',
    processingRefund: 'We are processing your refund',
    processingRefundDesc:
      'Once we issue the refund through your original payment method, you can check the progress here.',
    refundReceived: 'You have received the refund',
    refundReceivedDesc: 'The refund has been returned to you via your original payment method',
    // Refund status
    statusUnrefund: 'Not Refunded',
    statusRefunding: 'Cancelling',
    statusRefunded: 'Cancelled Successfully',
    statusRefundFailed: 'Cancellation Failed',
  },
  // Email verification related
  emailVerify: {
    searchOrders: 'Search Orders',
    step1Label:
      '1. Please enter the email address you used when booking, and we will send you a verification code',
    emailPlaceholder: 'Email',
    getCode: 'Get Code',
    resend: 'Resend',
    resendCountdown: 'Resend in {count}s',
    step2Label: '2. Please check your email and enter the 6-digit verification code below',
    codePlaceholder: 'Verification Code',
    pleaseEnterEmail: 'Please enter email address',
    pleaseEnterValidEmail: 'Please enter a valid email address',
    codeSent: 'Verification code sent, please check your email',
    sendFailed: 'Failed to send, please try again',
  },
}
